import { actionCreatorFactory } from 'typescript-fsa';
import { Instance } from '../../@types/instance';

const actionCreator = actionCreatorFactory('@@xver/instance');

export const setSelectedInstance = actionCreator<Instance | undefined>('setSelectedInstance');
